export default __webpack_public_path__ + "static/media/about_img.ca109635.png";